import * as types from "./mutation_types";
import deepmerge from "deepmerge";
import {defaultSettings} from "@/helpers/default";

export default {
  [types.RESET](state) {
    Object.assign(state, {
      error: "",
      isLoading: false,
      form: {}
    });
  },

  [types.SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.SET_USER](state, user) {
    Object.assign(state, {
      user: Object.assign({}, state.user, user)
    });
  },
  [types.SET_SITE_SETTINGS](state, site) {
    Object.assign(state, {
      site: Object.assign({}, state.site, site)
    });
  },
  [types.SET_FORM](state, data) {
    // dark #1D1D1D
    // dark-page #121212
    const final = deepmerge(defaultSettings, data.settings);

    const fieldsById = {};
    for(let screenkey in data.screens) {
      for (let fieldkeyF in data.screens[screenkey].fields) {
        const field = data.screens[screenkey].fields[fieldkeyF];
        fieldsById[field.id] = field;
      }
    }

    Object.assign(state, {
      error: "",
      form: data,
      settings: final,
      fieldsById: fieldsById
    });

    try {
      Object.entries(state.form.custom_scripts).forEach(([key, value]) => {
        const scriptEl = document.createElement('script');
        scriptEl.src = value;
        scriptEl.id = key;
        document.body.appendChild(scriptEl);
      });
    } catch (e) {
      console.log(e);
    }

  },

  [types.TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
